<template>
    <v-container class="container" fluid>
        <v-toolbar dark color="secondary">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text"
                > Fuel Statement {{title+' :'+srh.id}}</v-toolbar-title
            >
            <v-spacer></v-spacer>
                <v-btn icon left :to="to"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
        </v-toolbar>
        <v-card class="mb-5">
            <v-form ref="form" lazy-validation>
                <v-toolbar flat color="white">

                    <v-spacer></v-spacer>
                    <v-btn color="success" class="mx-4" @click="ExportFuelExpenseExcel">Excel
                        <v-icon class="ml-3" >mdi-microsoft-excel</v-icon>
                    </v-btn>
                    <v-btn
                        color="primary"
                        dark
                        @click="printFuelExpenseReport()"
                    >
                        print
                        <v-icon small right class="mr-2">
                            mdi-printer
                        </v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="titles"
                    :items="data"
                    :items-per-page="10"
                    class="elevation-1"
                    :loading="dataLoading"
                    loading-text="Loading... Please wait"
                >
                    <template v-slot:item.GST = {item}>
                        <td>{{ Number(item.GST).toFixed(2)}}</td>    
                    </template>
                    <template v-slot:item.Total = {item}>
                        <td>{{ Number(item.Total).toFixed(2)}}</td>    
                    </template>
                    <template slot="body.append">
                        <tr>
                            <th colspan="11" style="text-align: right;"> Total:</th>
                            <td> {{ Number(total).toFixed(2)}}</td>
                        </tr>
                       
                            
                    </template>
                </v-data-table>
            </v-form>
        </v-card>

        <v-dialog v-model="pdfDialog" width="1200px" heigth="800px">
            <iframe width="100%" height="1000px" :src="urlPdf"></iframe>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: 'ViewFuelStatement',
    data: function() {
        return {
            pdfDialog: false,
            urlPdf: '',
            total: 0,
            disabled: true,
            to:'',
            title:null,
            titles: [
                { text: 'Truck', value: 'shift_detail.truck.Truck' },
                { text: 'Driver', value: 'shift_detail.driver.Name' },
                { text: 'Province', value: 'Province' },
                { text: 'Date', value: 'Date' },
                { text: 'Type', value: 'expense_type.Type' },
                { text: 'Supplier', value: 'supplier.Supplier' },
                { text: 'Invoice No.', value: 'InvoiceNo' },
                { text: 'QTY', value: 'Qty' },
                { text: 'GST', value: 'GST' },
                { text: 'Total', value: 'Total' },
                { text: 'Actual Price', value: 'ActualPrice' },
                { text: 'Actual Cost', value: 'ActualCost' },
                { text: 'Stmt ID', value: 'Stid' },
                
            ],
            data: [],
            dataLoading: true,
            srh: ''
        };
    },
    mounted() {
        //if redirected from 'CheckStatements'
        if (this.$store.state.viewFuelStatements.from == 'checkStatements') {
            this.loadStatementsDetailsBySuppInvNo(
                this.$store.state.viewFuelStatementsSuppInvNo.suppInvNo
            );
            this.srh ={
                id:this.$store.state.viewFuelStatementsSuppInvNo.suppInvNo,
                StSp:0
            }
            this.title= 'SuppInvNo';
            this.to = '/administration/fuel/check-statements';
        }
        //if redirected from 'Fuel' search
        if (this.$store.state.viewFuelStatements.from == 'search') {
            var data = this.$store.state.searchFuelExpenseDetails;
            //search by suppInvNo
            this.srh ={
                id:data.searchValue,
                StSp:1
            }
            console.log(this.srh);
            if (data.searchParameter.value == 1) {
                this.loadStatementsDetailsBySuppInvNo(data.searchValue);
                this.srh.StSp= 0;
                
            this.title= 'SuppInvNo';
            } else if (data.searchParameter.value == 2) {
                //search by stnumber
                
            this.title= 'St Number';
                this.loadStatementsDetailsByStNum(data.searchValue);
            }
            this.to = '/administration/fuel';
        }
    },

    methods: {
        loadStatementsDetailsBySuppInvNo: function(suppInvNo) {
            axios
                .get(
                    'fuel-expense/details/' + suppInvNo,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log(response.data);
                    this.data = response.data;
                    this.getTotal(this.data);
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
                
                    this.dataLoading = false;
        },
        loadStatementsDetailsByStNum: function(stNum) {
            
            var str = this.$store;
            axios
                .get(
                    'fuel-expense/details/st/' + stNum,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log(response.data);
                    this.data = response.data;
                    this.getTotal(this.data);
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'St Number Not Found.'
                        });
                    }
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
                
                this.dataLoading = false;
        },
        printFuelExpenseReport: async function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                stID: this.srh.id,
                StSp: this.srh.StSp
            }
            axios
                .post('fuel-expense/statement-report' , parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Fuel-Expense.pdf');
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                   
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        ExportFuelExpenseExcel: async function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                stID: this.srh.id,
                StSp: this.srh.StSp
            }
            axios
                .post('fuel-expense/statement-report/excel' , parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    if(this.srh.StSP != 0 ){
                     link.setAttribute('download', 'Statement: '+this.srh.id+'.xlsx');
                    }else{
                        link.setAttribute('download', 'SuppInvNo: '+this.srh.id+'.xlsx');
                    }
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getTotal: function(array) {
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                this.total += element.ActualCost;
            }
        }
    }
};
</script>

<style></style>
